const getRoleTitleSchema = (preTag) => ({
  type: `${preTag}_title`,
  min: 1,
  max: 1,
});

const getDateSchema = (preTag) => ({
  type: preTag,
});

const getContentEditableDivSchema = (preTag) => ({
  type: preTag,
});

const getRoleScoreSchema = (preTag) => ({
  type: preTag,
});

export default (params) => {
  const { preTag } = params;

  let nodes;
  if (preTag === 'work_experience') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_job`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_role_description`),
          getContentEditableDivSchema(`${preTag}_role_achievements`),
        ],
      },
    ];
  } else if (preTag === 'education') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_degree`),
          getRoleScoreSchema(`${preTag}_cgpa`),
          getRoleTitleSchema(`${preTag}_field`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_role_description`),
        ],
      },
    ];
  } else if (preTag === 'awards_and_honors') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_award`),
          getDateSchema(`${preTag}_issue_date`),
          getContentEditableDivSchema(`${preTag}_award_description`),
        ],
      },
    ];
  } else if (preTag === 'volunteer_work') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_role`),
          getRoleTitleSchema(`${preTag}_cause`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_role_description`),
        ],
      },
    ];
  } else if (preTag === 'courses') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_course`),
          getDateSchema(`${preTag}_completion_date`),
          getContentEditableDivSchema(`${preTag}_course_description`),
        ],
      },
    ];
  } else if (preTag === 'conferences') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_conference`),
          getDateSchema(`${preTag}_date`),
          getContentEditableDivSchema(`${preTag}_conference_description`),
        ],
      },
    ];
  } else if (preTag === 'certifications') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_certification`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_certification_description`),
        ],
      },
    ];
  } else if (preTag === 'references') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_reference`),
          getRoleTitleSchema(`${preTag}_reference_name`),
          getRoleTitleSchema(`${preTag}_reference_email`),
        ],
      },
    ];
  } else if (preTag === 'patents') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_patent`),
          getRoleTitleSchema(`${preTag}_patent_id`),
          getRoleTitleSchema(`${preTag}_patent_status`),
          getRoleTitleSchema(`${preTag}_patent_country`),
          getRoleTitleSchema(`${preTag}_patent_url`),
          getDateSchema(`${preTag}_patent_date`),
          getContentEditableDivSchema(`${preTag}_patent_description`),
        ],
      },
    ];
  } else if (preTag === 'testScores') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_test`),
          getRoleScoreSchema(`${preTag}_cgpa`),
          getDateSchema(`${preTag}_date`),
          getContentEditableDivSchema(`${preTag}_test_description`),
        ],
      },
    ];
  } else if (preTag === 'projects') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_project`),
          getRoleTitleSchema(`${preTag}_url`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_project_description`),
        ],
      },
    ];
  } else if (preTag === 'research_experience') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_research`),
          getRoleTitleSchema(`${preTag}_url`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_research_description`),
        ],
      },
    ];
  } else if (preTag === 'leadership') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_role`),
          getRoleTitleSchema(`${preTag}_url`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_role_description`),
        ],
      },
    ];
  } else if (preTag === 'associations') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_association`),
          getRoleTitleSchema(`${preTag}_url`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_association_description`),
        ],
      },
    ];
  } else if (preTag === 'extra_curricular') {
    nodes = [
      {
        match: [
          getRoleTitleSchema(`${preTag}_activity`),
          getRoleTitleSchema(`${preTag}_url`),
          getDateSchema(`${preTag}_from`),
          getDateSchema(`${preTag}_to`),
          getContentEditableDivSchema(`${preTag}_activity_description`),
        ],
      },
    ];
  } else if (preTag === 'skill') {
    nodes = [
      {
        match: [getRoleTitleSchema(preTag)],
      },
    ];
  }
  return {
    nodes,
  };
};
